type RequestFunction<R> = (...args: any[]) => Promise<R>;

interface QueueItem {
  method: RequestFunction<any>;
  resolve: (value?: any) => void;
  reject: (reason?: any) => void;
  // customThen: (value?: any) => any;
  customCatch?: (value?: any) => any;
  params?: any;
}

export class RequestQueue {
  private queue: QueueItem[];

  constructor() {
    this.queue = [];
  }

  public push(item: QueueItem): void {
    this.queue.push(item);
  }

  public shift(): QueueItem | undefined {
    return this.queue.shift();
  }

  public isEmpty(): boolean {
    return this.queue.length === 0;
  }

  public clear(): void {
    this.queue = [];
  }

  public executeStoredRequests() {
    if (this.queue.length === 0) return;

    this.queue.forEach(request => {
      const { method, params, resolve, customCatch } = request;
      method(...(params ?? []))
        .then(resolve)
        .catch(customCatch);
    });

    this.queue = [];
  }
}

export default RequestQueue;
